export const _deleted = (state, { id }) => {
  delete state[id];
  return { ...state };
};
